<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Nueva venta</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Ventas</a></li>
        <li class="breadcrumb-item active">Nueva venta</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <tabs class="tabs-default">
          <tab id="venta" name="Venta">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Fecha</label>
                    <datepicker :format="format" input-class="form-control" :language="es" v-model="saleDate" />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Localidad</label>
                    <multi-select v-model="place" :options="places" :allow-empty="false" :show-labels="false"
                      :searchable="true" label="name" track-by="id" placeholder="Seleccione una localidad" />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label>Cliente</label>
                    <multi-select v-model="client" :options="clients" :allow-empty="false" :show-labels="false"
                      :searchable="true" label="name" track-by="name" placeholder="Seleccione un cliente"
                      @search-change="searchClients" :internal-search="false" :loading="isLoadingClients"
                      :custom-label="nameWithNit">
                      <template slot="beforeList">
                        <button class="btn btn-success btn-lg btn-block" @click="openModalClient">Nuevo Cliente <i
                            class="icon-fa icon-fa-plus" /></button>
                      </template>
                    </multi-select>
                  </div>
                </div>
                <!-- <div class="col-lg-1">
                  <button class="btn btn-success"><i class="icon-fa icon-fa-plus"/></button>
                </div> -->
                <div class="col-lg-2">
                  <div class="form-group">
                    <label>Crédito autorizado</label>
                    <input type="text" v-model="client.credit_limit" class="form-control" readonly="true" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Documento</label>
                    <multi-select v-model="document" :options="documents" :allow-empty="false" :show-labels="false"
                      label="name" track-by="id" placeholder="Seleccione un documento" :loading="isLoadingDocuments"
                      @input="getCorrelative(document.name)" />
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label>Serie</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model.number="correlative"
                        aria-label="Recipient's username" aria-describedby="basic-addon2">
                      <div class="input-group-append">
                        <button class="btn btn-outline-primary" v-tooltip="{
                          content: 'Obtener correlativo',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 30,
                        }" :disabled="isLoadingCorrelative" @click="getCorrelative" type="button"><i
                            class="icon-fa icon-fa-undo" /></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Productos</label>
                    <multi-select
                      ref="products"
                      v-model="product"
                      :options="products"
                      :allow-empty="false"
                      :show-labels="false"
                      :searchable="true"
                      label="name"
                      track-by="name"
                      placeholder="Seleccione sus productos"
                      @search-change="searchProducts"
                      :internal-search="false"
                      :loading="isLoadingProducts"
                      :custom-label="nameWithCode" @close="addProduct">
                    </multi-select>
                  </div>
                </div>
                <div class="col-lg-1">
                  <div class="form-group">
                    <label>Agregar</label>
                    <button class="btn btn-success btn-block" @click="addProduct"><i class="icon-fa icon-fa-plus" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Productos</label>
                    <table-component :data="selectProducts" table-class="table" :show-filter="false">
                      <table-column show="code" label="Código" />
                      <table-column show="nameProduct" label="Producto" />
                      <table-column show="stock" label="Existencia">
                        <template slot-scope="row">
                          {{myquantity(row['stock'])}}
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" show="sales_price" label="Precio">
                        <template slot-scope="row">
                          {{mymoney(row['sales_price'])}}
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" label="Cantidad">
                        <template slot-scope="row">
                          <input type="number" class="form-control"
                            v-model.number="selectProducts[getIndex(selectProducts,row['id'])].quantity"
                            @blur="validateQuantity(getIndex(selectProducts,row['id']))"
                            :class="{ 'is-invalid': selectProducts[getIndex(selectProducts,row['id'])].error===true }"
                            :ref="'quantity-'+getIndex(selectProducts,row['id'])"
                            @keyup.enter="refMultiple('quantity',getIndexPlus(selectProducts,row['id']))" />
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" label="Descuento">
                        <template slot-scope="row">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <select class="form-control"
                                v-model="selectProducts[getIndex(selectProducts,row['id'])].typeDiscount"
                                @change="changeDiscount(getIndex(selectProducts,row['id']))"
                                :disabled="discountSetting">
                                <option value="Q" title="Quetzales">Q</option>
                                <option value="%" title="Porcentaje">%</option>
                              </select>
                            </div>
                            <input type="number" class="form-control"
                              v-model.number="selectProducts[getIndex(selectProducts,row['id'])].discount"
                              @blur="validateQuantity(getIndex(selectProducts,row['id']))"
                              :ref="'discount-'+getIndex(selectProducts,row['id'])"
                              @keyup.enter="refMultiple('discount',getIndexPlus(selectProducts,row['id']))"
                              :readonly="discountSetting" />
                          </div>
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" label="Subtotal">
                        <template slot-scope="row">
                          {{mymoney(row['subtotal'])}}
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" label="Acciones">
                        <template slot-scope="row">
                          <div class="btn-group mr-2" role="group" aria-label="First group">
                            <button class="btn btn-danger" v-tooltip.top-center="'Quitar producto'" @click="removeProduct(getIndex(selectProducts,row['id']))"><i
                                class="icon-fa icon-fa-trash" />
                            </button>
                            <span :class="selectProducts[getIndex(selectProducts,row['id'])].state===1?'btn btn-success':'btn btn-danger'">{{facturaono(selectProducts[getIndex(selectProducts,row['id'])].state)}}</span>
                          </div>
                        </template>
                      </table-column>
                      <template slot="tfoot">
                        <tr>
                          <th colspan="6" class="text-right">
                            <h6 class="font-weight-bold">Total</h6>
                          </th>
                          <th>
                            <h6 class="font-weight-bold">{{mymoney(total)}}</h6>
                          </th>
                        </tr>
                      </template>
                    </table-component>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-9">
                  <div class="form-group">
                    <label>Comentario</label>
                    <input class="form-control" v-model="description" placeholder="Comentario sobre la venta"
                      ref="description" @keyup.enter="changeRef('buttonSave')">
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <button slot="button" class="btn btn-block btn-theme ladda-button" data-style="expand-right"
                      @click="openModalReferenceClient" ref="buttonSave" @keyup.enter="openModalReferenceClient">Guardar venta</button>
                  </div>
                </div>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
    </div>
    <!-- MODALES -->
    <sweet-modal ref="modal_client" title="Nuevo cliente" @close="closeModalClient" @open="changeRef('nameClient')" hide-close-button blocking>
      <!-- BEGIN FORM -->
      <div class="card-body">
        <div class="form-group">
          <label>Nit cliente</label>
          <input ref="nitClient" class="form-control" placeholder="C/F" :class="{ 'is-invalid': $v.clientNit.$error }"
            v-model.trim="clientNit" @blur="$v.clientNit.$touch()" @keyup.enter="changeRef('nameClient')">
          <div v-if="$v.clientNit.$error">
            <span v-if="!$v.clientNit.nit" class="help-block help-block-error">El número de nit no es válido.</span>
          </div>
        </div>
        <div class="form-group">
          <label>Nombre</label>
          <input ref="nameClient" class="form-control" :class="{ 'is-invalid': $v.clientName.$error }"
            v-model.trim="clientName" @keyup.enter="changeRef('addressClient')">
        </div>
        <div class="form-group">
          <label>Dirección</label>
          <input ref="addressClient" class="form-control" :class="{ 'is-inva/lid': $v.clientAddress.$error }"
            v-model.trim="clientAddress" @keyup.enter="changeRefVue('telephoneClient')">
        </div>
        <div class="form-group">
          <label>Teléfono</label>
          <masked-input ref="telephoneClient" class="form-control" v-model="clientTelephone"
            :mask="[ /\d/,/\d/, /\d/, /\d/, '-',/\d/, /\d/, /\d/, /\d/]" :guide="false" :keep-char-positions="true"
            :show-mask="true" @keyup.enter="changeRef('clientSave')" />
        </div>
      </div>
      <button slot="button" type="button" class="btn btn-danger" @click="$refs.modal_client.close()">Cancelar</button>
      <button ref="clientSave" slot="button" type="button" class="btn btn-primary ladda-button"
        data-style="expand-right" @click="saveClient">Guardar</button>
      <!-- END FORM -->
    </sweet-modal>
    <sweet-modal ref="modal_client_reference" title="Nombre del cliente" hide-close-button blocking>
      <div class="card-body">
        <div class="form-group">
          <label>Nombre del cliente</label>
          <input class="form-control" type="text" v-model="nameReference">
        </div>
      </div>
      <button slot="button" type="button" class="btn btn-danger" @click="$refs.modal_client_reference.close()">Cancelar</button>
      <button ref="clientSave" slot="button" type="button" class="btn btn-primary ladda-button"
        data-style="expand-right" @click="validateRefernceClient">Guardar</button>
    </sweet-modal>
    <!-- MODAL CREAR CLIENTE -->
    <!-- MODAL NAME REFERENCE -->
    <!-- END -->
  </div>
</template>
<script>

  import { Tabs, Tab } from 'vue-tabs-component'
  import Datepicker from 'vuejs-datepicker'
  import { en, es } from 'vuejs-datepicker/dist/locale'
  import Multiselect from 'vue-multiselect'
  import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
  import ladda from "ladda";
  import { required, between } from "vuelidate/lib/validators";
  import { xelacode } from '../../../helpers/xelacode'
  import MaskedInput from 'vue-text-mask'
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  import { TableComponent, TableColumn } from "vue-table-component";
  import moment from "moment";

  // VALIDACION DPI
  let nit = (value) => xelacode.nitIsValid(value);
  // let maxStock = (value) => xel
  export default {
    components: {
      'tabs': Tabs,
      'tab': Tab,
      Datepicker,
      'multi-select': Multiselect,
      SweetModal,
      SweetModalTab,
      'masked-input': MaskedInput,
      TableComponent,
      TableColumn,
    },
    data() {
      return {
        nameReference:'',
        saleDate: new Date().toLocaleString().slice(0,10),
        advcolors: '',
        format: 'dd/MM/yyyy',
        en: en,
        es: es,
        places: [],
        place: [],
        clients: [],
        client: {
          id: 0,
          name: 'C/F',
          credit_limit: xelacode.money(0),
          nit: 'C/F'
        },
        defaultClient: {
          id: 0,
          name: 'C/F',
          credit_limit: xelacode.money(0),
          nit: 'C/F'
        },
        isLoadingClients: false,
        // VARIABLES NEW CLIENT
        clientNit: '',
        clientName: '',
        clientAddress: '',
        clientTelephone: '',
        state: 0,
        mask_quetzal: createNumberMask({
          prefix: 'Q ',
          suffix: '',
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ',',
          allowDecimal: true,
          decimalSymbol: '.',
          decimalLimit: 2, // how many digits allowed after the decimal
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false,
          allowLeadingZeroes: false,
        }),
        // VARIABLES DOCUMENTS
        document: [],
        documents: [],
        correlative: '',
        isLoadingDocuments: false,
        isLoadingCorrelative: false,
        // VARIABLES PRODUCTS
        product: '',
        products: [],
        isLoadingProducts: false,
        // VARIABLES TABLES PRODUCTOS
        selectProducts: [],
        mask_number: createNumberMask({
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false
        }),
        // VARIABLES
        total: 0,
        type: "Q",
        description: "",
        user: [],
        discountSetting: false
      }
    },
    validations: {
      clientNit: {
        nit
      },
      clientName: {
        required
      },
      clientAddress: {
        required
      },
    },
    methods: {
      setValue(value){
        var list=[];
        list.push(value);
        return list[0];
      },
      changeSpecialPrice(item){
        let vm=this;
        if(vm.selectProducts[item].specialPrice===1){
          vm.selectProducts[item].specialPrice=0;
          vm.selectProducts[item].sales_price=vm.setValue(vm.selectProducts[item].defaultPrice);
          vm.calculateSubtotal(item);
        }else{
          vm.selectProducts[item].specialPrice=1;
          vm.selectProducts[item].sales_price=vm.setValue(vm.selectProducts[item].defaultSpecialPrice);
          vm.calculateSubtotal(item);
        }
      },
      // METHOD REF TI INPUT VUE
      changeRefVue(nameRef) {
        this.$refs[nameRef].$el.focus();
      },
      // METHOD TO REF
      changeRef(nameRef) {
        this.$refs[nameRef].focus();
      },
      changeRefInput(nameRef) {
        this.$refs[nameRef].focus();
      },
      // METHOD NUMBERS TWO DECIMAL
      parseDecimal(value) {
        return parseFloat(this.parseDecimalFixed(value));
      },
      parseDecimalFixed(value) {
        return parseFloat(value).toFixed(2);
      },
      // METHOD QUETZALES
      mymoney(value) {
        return xelacode.money(parseFloat(value));
      },
      //factura o no
      facturaono(estado){
        let devolver = '';
        if(estado === 1){
          devolver = '.' //ya me pidieron que quite esto, no lo volvere a agregar
        }
        else if(estado === 2){
          devolver = '.'
        }
        else{
          devolver = 'No valido'
        }
        return devolver;
      },
      myquantity(value) {
        return xelacode.quantity(value);
      },
      selectPlaces(id,name) {
        let me = this;
        var url = '/api/admin/place/getSelect';
        axios.get(url).then(function (response) {
          var respuesta = response.data;
          me.places = respuesta.place;
          me.place = me.places.find(x=>x.id===id);
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      searchClients(filter) {
        let me = this;
        var url = `/api/sale/getClients?filter=${filter}`;
        this.isLoadingClients = true;
        axios.get(url).then(function (response) {
          me.clients = response.data.data;
          me.clients.unshift(me.defaultClient);
          me.isLoadingClients = false;
        })
          .catch(function (error) {
            console.log(error);
            me.isLoadingClients = false;
          });
      },
      nameWithNit({ name, nit }) {
        if (name === 'C/F')
          return 'C/F'
        else
          return `${nit}|${name}`;
      },
      openModalClient() {
        this.state = 1;
        this.$v.$reset();
        this.$refs.modal_client.open();
      },
      saveClient() {
        var l = ladda.create(document.querySelector(".ladda-button"));
        this.$v.clientNit.$touch();
        let me = this;
        if (this.$v.$invalid) {
          toastr.error("Revise los campos", "Error");
        } else {
          l.start();
          axios
            .post("/api/sale/newClient", {
              name: this.clientName,
              address: this.clientAddress,
              number: this.clientTelephone,
              nit: this.clientNit
            })
            .then(function (response) {
              toastr.success(response.data.message, "Listo");
              me.client.id = response.data.id;
              me.client.name = response.data.name;
              me.client.nit = response.data.nit;
              me.client.credit_limit = response.data.credit_limit;
              l.stop();
              me.$refs.modal_client.close();
            })
            .catch(function (error) {
              l.stop();
              toastr.error(error.response.data.message, "Error");
            });
        }
      },
      closeModalClient() {
        this.state = 0;
        this.clientName = "";
        this.clientAddress = "";
        this.clientTelephone = "";
        this.clientNit = "";
      },
      // METHODS FOR DOCUMENTS
      getDocuments() {
        let me = this;
        var url = `/api/sale/getDocuments`;
        this.isLoadingDocuments = true;
        axios.get(url).then(function (response) {
          me.documents = response.data;
          me.isLoadingDocuments = false;
          me.document=me.documents[1];
          me.getCorrelative(me.document.name);
        })
          .catch(function (error) {
            console.log(error);
            me.isLoadingDocuments = false;
          });
      },
      getCorrelative(name) {
        if (name === null || name === '' || typeof (name) === "undefined") {
          return;
        }
        let me = this;
        var url = `/api/sale/getCorrelative?name=${name}`;
        this.isLoadingCorrelative = true;
        axios.get(url).then(function (response) {
          me.correlative = response.data.correlative[0].number;

          me.isLoadingCorrelative = false;
        })
          .catch(function (error) {
            console.log(error);
            me.isLoadingCorrelative = false;
          });
      },
      // END METHODS FOR DOCUMENTS
      // METHODS PRODUCTS
      nameWithCode({ name, code }) {
        return `${code} | ${name}`;
      },
      searchProducts(filter) {
        let me = this;
        var url = `/api/sale/getProducts?place=${this.place.id}&filter=${filter}`;
        this.isLoadingProducts = true;
        axios.get(url).then(function (response) {
          me.products = response.data.data;
          me.isLoadingProducts = false;
        })
          .catch(function (error) {
            console.log(error);
            me.isLoadingProducts = false;
          });
      },
      defaultProducts(place) {
        let me = this;
        var url = `/api/sale/getProducts?place=${place}&filter=A`;
        this.isLoadingProducts = true;
        axios.get(url).then(function (response) {
          me.products = response.data.data;
          me.isLoadingProducts = false;
        })
          .catch(function (error) {
            console.log(error);
            me.isLoadingProducts = false;
          });
      },
      // END METHODS PRODUCTS
      // METHOD ADD PRODUCTS TO TABLE
      addProduct() {
        if (typeof (this.selectProducts.find(x => x.id === this.product.id)) !== "undefined") {
          toastr.error("El producto ya esta agregado", "Error");
          this.product = '';
          return;
        } else if (this.product === [] || this.product === '' || this.product === null) {
          toastr.error("Seleccione un producto", "Error");
          this.product = '';
          return;
        }
        this.selectProducts.push(this.product);
        this.calculateSubtotal(this.selectProducts.length - 1);
        this.product = '';
        this.changeRefVue('products');
      },
      removeProduct(item) {
        this.selectProducts.splice(item, 1);
        this.calculateTotal();
      },
      getIndex(list, id) {
        return list.findIndex((e) => e.id == id)
      },
      getIndexPlus(list, id) {
        return list.findIndex((e) => e.id == id) + 1;
      },
      validateQuantity(item) {
        if (typeof (this.selectProducts[item].quantity) != "undefined") {
          if (this.selectProducts[item].quantity > this.selectProducts[item].stock) {
            this.selectProducts[item].quantity = this.selectProducts[item].stock;
            toastr.error("Existencia insuficiente", "Error");
            this.refMultiple('quantity', item);
          } else if (this.selectProducts[item].quantity < 1) {
            this.selectProducts[item].quantity = 1;
            toastr.error("La cantidad debe ser al menos 1", "Error");
            this.refMultiple('quantity', item);
          }
          this.calculateSubtotal(item);
        }
      },
      calculateSubtotal(item) {
        this.selectProducts[item].subtotal = parseFloat(this.selectProducts[item].quantity) * parseFloat(this.selectProducts[item].sales_price);
        this.calculateDiscount(item);
        this.calculateTotal();
      },
      calculateTotal() {
        let me = this;
        this.total = 0;
        this.selectProducts.forEach(item => {
          me.total = me.parseDecimal(me.total) + me.parseDecimal(item.subtotal);
        });
      },
      openModalReferenceClient(){
        if(this.selectProducts.length<1){
          toastr.error('No hay productos agregados', 'Error');
          return;
        }
        let vm=this;
        if(vm.client.id===0&&vm.nameReference==='')
          vm.$refs.modal_client_reference.open();
        else
          vm.saveSale();
      },
      validateRefernceClient(){
        let vm=this;
        if(vm.nameReference===''){
          toastr.error('Ingrese un nombre de cliente','Error')
          return;
        }
        vm.saveSale();
      },
      saveSale() {
        var l = ladda.create(document.querySelector(".ladda-button"));
        l.start();
        let me=this;
        axios.post('/api/sale/newSale',{

          sale_date: moment(me.saleDate).format('yyyy-MM-D'),
          description: me.description,
          document_number: me.correlative,
          nit: me.client.nit,
          total: me.total,
          credit:0,
          credit_limit:me.saleDate,
          state: 1,
          credit_state:0,
          idclient: me.client.id,
          checker: me.user.id,
          seller: me.user.id,
          user_created: me.user.id,
          user_updated: me.user.id,
          iddocument: me.document.id,
          idplace: me.place.id,
          products: JSON.stringify(me.selectProducts),
          nameReference: me.nameReference,
          client: JSON.stringify(me.client)
        }).then((response)=>{
          me.$router.push({name:'VentaLista',
                          params:{
                            message:response.data.message
                          }
          })
          l.stop();
        }).catch((error)=>{
          toastr.error(error.response.data.message, "Error");
          l.stop();
        });
      },
      calculateDiscount(item) {
        if (this.selectProducts[item].discount > 0 && this.selectProducts[item].quantity > 0) {
          if (this.selectProducts[item].typeDiscount === "Q") {
            if (this.selectProducts[item].discount <= this.selectProducts[item].subtotal)
              this.selectProducts[item].subtotal = this.selectProducts[item].subtotal - this.selectProducts[item].discount;
            else {
              this.selectProducts[item].discount = 0;
              toastr.error('El descuento no puede ser mayor al subtotal del producto', 'Error');
              this.refMultiple('discount', item);
            }
          } else if (this.selectProducts[item].typeDiscount === "%") {
            if ((this.selectProducts[item].subtotal * (this.selectProducts[item].discount / 100)) <= this.selectProducts[item].subtotal)
              this.selectProducts[item].subtotal = this.parseDecimal(this.selectProducts[item].subtotal - (this.selectProducts[item].subtotal * (this.selectProducts[item].discount / 100)));
            else {
              this.selectProducts[item].discount = 0;
              toastr.error('El descuento no puede ser mayor al subtotal del producto', 'Error');
              this.refMultiple('discount', item);
            }
          }
        } else {
          this.selectProducts[item].discount = 0;
        }
      },
      changeDiscount(item) {
        this.selectProducts[item].discount = 0;
        this.calculateSubtotal(item);
      },
      refMultiple(input, item) {
        let inputLength = this.selectProducts.length - 1;
        if (item > inputLength) {
          this.changeRef('description');
        } else {
          this.changeRefInput(`${input}-${item}`);
        }
      },
      getUser() {
        let me = this;
        axios.get('/api/sale/getUser')
          .then((response) => {
            me.user = response.data;
            me.getSetting('Ventas', 'Permiso para permitir hacer descuentos a usuarios en una venta', me.user.id);
            me.selectPlaces(me.user.placeId);
            me.defaultProducts(me.user.placeId);
          }).catch((error) => {
            console.log(error);
          })
      },
      getSetting(module, option, user) {
        let me = this;
        axios.get(`/api/sale/getSetting?module=${module}&module=${option}&user=${user}`)
          .then((response) => {
            me.discountSetting = response.data.setting;
          }).catch((error) => {
            console.log(error);
          })
      }
      // END METHODS
    },
    mounted() {
      this.$emit('input');
      this.getUser();
      this.searchClients('A');
      this.getDocuments();
      this.getCorrelative('Factura');

    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/sale/Sale.vue